module.exports = function(service) {
	'use strict'
	service.factory('fileReaderImage', fileReaderImage);
	fileReaderImage.$inject = [];
	function fileReaderImage() {
	    return function(file,cb) {
            var reader = new FileReader();
            reader.onload = function(event) {
                var img = new Image();
                img.onload = function() {
                    var width = img.width;
                    var height = img.height;
                    cb(width, height)
                };
                img.src = event.target.result;
            }
            reader.readAsDataURL(file);
            
	    }
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/fileReaderImageService.js
// module id = 603
// module chunks = 0